import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function IspNode1(props) {
    return <NodeWithMultipleHandles {...props} nodeType="isp1" />;
}
